module.exports = __webpack_public_path__ + "img/newsImg5.33a9734a.png";